var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-box',_vm._b({staticClass:"input-container"},'a-box',_vm.boxProps,false),[_c('input',_vm._g(_vm._b({ref:"input",staticClass:"input",attrs:{"type":"text"},domProps:{"value":_vm.value}},'input',Object.assign({}, _vm.$attrs,
      _vm.elementBindings),false),Object.assign({}, _vm.$listeners,
      {input: _vm.update})))])}
var staticRenderFns = []

export { render, staticRenderFns }